import { Switch, Route } from "react-router-dom";
import {
  Home,
  Projects,
  Properties,
  SingleProject,
  SingleProperty,
} from "./pages/en";
import {
  HomeAr,
  ProjectsAr,
  PropertiesAr,
  SingleProjectAr,
  SinglePropertyAr,
} from "./pages/ar";
import NotFound from "./pages/NotFound";
// import ErrorBoundary from "./components/ErrorBoundary";
// for return commit

function App() {
  return (
    
      <div className="App">
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/projects">
            <Projects />
          </Route>
          <Route exact path="/properties">
            <Properties />
          </Route>
          <Route exact path="/projects/:slug">
            <SingleProject />
          </Route>
          <Route exact path="/properties/:slug">
            <SingleProperty />
          </Route>

          <Route exact path="/ar">
            <HomeAr />
          </Route>
          <Route exact path="/ar/projects">
            <ProjectsAr />
          </Route>
          <Route exact path="/ar/properties">
            <PropertiesAr />
          </Route>
          <Route exact path="/ar/projects/:slug">
            <SingleProjectAr />
          </Route>
          <Route exact path="/ar/properties/:slug">
            <SinglePropertyAr />
          </Route>
          <Route>
            <NotFound />
          </Route>
        </Switch>
      </div>
    
  );
}
export default App;
